import { MessageService } from './../../services/message.service';
import { PromptUnsavedChanges } from './../../guards/savechanges.guard';
import { Claims } from './../../types/enums/claims';
import { Component, inject, OnInit, viewChild } from '@angular/core';
import { MyUserInformationComponent } from '../../components/myuserprofile/tabs/myuserinformation/myuserinformation.component';
import { MyUserSettingsComponent } from '../../components/myuserprofile/tabs/myusersettings/myusersettings.component';
import { MyUserNotificationsComponent } from './tabs/myusernotifications/myusernotifications.component';
import { AuthService } from '../../services';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from '../../classes';
import { CheckAccessDirective } from '../../directives/access.directive';
import { MyUserSettingsComponent as MyUserSettingsComponent_1 } from './tabs/myusersettings/myusersettings.component';

import { MyUserInformationComponent as MyUserInformationComponent_1 } from './tabs/myuserinformation/myuserinformation.component';
import { TabsModule } from 'primeng/tabs';
import { TARGET } from "../../types/constants/appconstants";

enum TabIndex {
    UserInformation = 0,
    UserSettings = 1,
    UserNotifications = 2
}

@Component({
    selector: 'my-userprofile',
    templateUrl: './myuserprofile.component.html',
    styleUrls: ['./myuserprofile.component.scss'],
    standalone: true,
    imports: [TabsModule, MyUserInformationComponent_1, MyUserSettingsComponent_1, CheckAccessDirective, MyUserNotificationsComponent]
})
export class MyUserProfileComponent extends UnsubscribeOnDestroy implements OnInit, PromptUnsavedChanges {
    private authService = inject(AuthService);
    private messageService = inject(MessageService);
    private target = inject(TARGET);
    
    canManageTodaysSchedules: boolean = false;
    Claims = Claims;
    isAppWide: boolean;
    _hasChanges: boolean = false;

    readonly myInfoComp = viewChild(MyUserInformationComponent);
    readonly mySettingsComp = viewChild(MyUserSettingsComponent);
    readonly myNotificationsComp = viewChild(MyUserNotificationsComponent);

    tabIndex: number = TabIndex.UserInformation;

    constructor() {
        super();
    }

    hasChanges(): boolean {
        return this._hasChanges;
    }

    ngOnInit() {
        this.authService.hasClaim(this.Claims.manage_todays_schedules).pipe().subscribe((canManageTodaysSchedules: boolean) => {
            this.canManageTodaysSchedules = canManageTodaysSchedules;
        });

        this.getAppWideRoleStatus();
        if (this.isAppWide && this.tabIndex !== TabIndex.UserInformation) {
            this.tabIndex = TabIndex.UserInformation;
        }
        this.subscribeToMessageService();
    }

    subscribeToMessageService() {
        // subscribe to sidebar component messages
        this.messageService.getMessage()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((message: any) => {
                switch (message.key) {
                    case "hasChanges":
                        this._hasChanges = message.value;
                        break;
                    default:
                        break;
                }
            });
    }

    getAppWideRoleStatus(): void {
        this.isAppWide = this.authService.getClaimValue(Claims.orgAll);
    }

    //Temporary hide in Stage and prod.  This will be removed when Todays schedule is ready for Prod
    IsNotProdOrStage(): boolean {
        return this.target === "dev" || this.target === "qa" || this.target === "local";
    }
}
